import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { forgotPasswordRequest } from '@services/auth.service'

import './forgot-password-form.styl'

function ForgotPasswordForm() {
  const navigate = useNavigate()

  const [errorMessage, setErrorMessage] = useState()
  const [email, setEmail] = useState('')
  const [emailHasBeenSent, setEmailHasBeenSent] = useState(false)

  const onSubmit = async (e) => {
    e.preventDefault()

    try {
      await forgotPasswordRequest(email)
      localStorage.setItem('forgotPasswordEmail', email)
      setEmailHasBeenSent(true)
    } catch (err) {
      setErrorMessage(err?.response?.data?.message || 'Something went wrong requesting a reset code')
    }
  }

  if (emailHasBeenSent) {
    return (
      <div className="forgot-password-form">
        <h1 className="forgot-password-form__title">Reset password</h1>
        <p className="forgot-password-form__intro">
          If an account with the email
          {' '}
          <strong>{email}</strong>
          {' '}
          exists, a recovery email has been sent.
          Please check your inbox and follow the instructions to reset your password.
        </p>
        <button
          type="button"
          className="forgot-password-form__return-button"
          onClick={() => navigate('/login')}
        >
          <span>Return to sign in</span>
        </button>
      </div>
    )
  }

  return (
    <form className="forgot-password-form" onSubmit={onSubmit}>
      <h1 className="forgot-password-form__title">Reset password</h1>
      <p className="forgot-password-form__intro">
        Enter the email address linked to your account, and we&apos;ll send you info on how to reset your password.
      </p>

      <div className="forgot-password-form__inputs">
        <div className="forgot-password-form__inputs__field">
          <input
            onChange={e => setEmail(e.target.value)}
            placeholder="Email"
            type="email"
            value={email}
          />
        </div>
      </div>

      {errorMessage && (
        <div className="forgot-password-form__error">
          {errorMessage}
        </div>
      )}

      <button
        type="submit"
        className="forgot-password-form__submit"
        disabled={!email}
      >
        <span>Send recovery code</span>
      </button>
      <button
        type="button"
        className="forgot-password-form__return-link"
        onClick={() => navigate('/login')}
      >
        <span>Return to sign in</span>
      </button>
    </form>
  )
}

export default ForgotPasswordForm
